module.exports = __webpack_public_path__ + "static/media/quikview_1.964a843b.ico";